import React, { createContext, useContext, useReducer } from "react";
import { initialState, menusReducer, MenusState, ACTION_TYPES } from "./menus-reducer";

type MenusContextType = {
    state: MenusState;
    dispatch: React.Dispatch<any>;
};

const MenusContext = createContext<MenusContextType | undefined>(undefined);

export const MenusProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [state, dispatch] = useReducer(menusReducer, initialState);

    return (
        <MenusContext.Provider value={{ state, dispatch }}>
            {children}
        </MenusContext.Provider>
    );
};

export const useMenusState = () => {
    const context = useContext(MenusContext);
    if (!context) {
        throw new Error("useMenusState must be used within MenusProvider");
    }
    return context.state;
};

export const useMenusDispatch = () => {
    const context = useContext(MenusContext);
    if (!context) {
        throw new Error("useMenusDispatch must be used within MenusProvider");
    }
    return context.dispatch;
};
